import React from "react";
import styles from "./attachmentPreviewModal.module.css";
import { Button } from "@mui/material";
import { Close, CloudDownload } from "@mui/icons-material";
import config from "../../../service/config";

const AttachmentPreviewModal = ({ fileName, reason, onClose }) => {
  const baseUrl = `${config.node_api_endpoint}`;
  return (
    <div className={styles.backdrop}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <span className={styles.fileName}>{fileName}</span>
          <button className={styles.closeBtn} onClick={onClose}>
            <Close />
          </button>
        </div>

        <div className={styles.imageContainer}>
          <img
            // src={`${baseUrl}/uploads/${fileName}`}
            src={`${baseUrl}/files/${fileName}`}
            alt="Attachment"
            className={styles.image}
          />
        </div>

        <div className={styles.actions}>
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "#ffffff",
              color: "#2348AB",
              border: "1px solid #2348AB",
            }}
            startIcon={<CloudDownload />}
            // href={`${baseUrl}/uploads/${fileName}`}
            href={`${baseUrl}/files/${fileName}`}
            download
          >
            Download
          </Button>

          {/* <Button
            variant="contained"
            sx={{
              backgroundColor: "#ffffff",
              color: "#2348AB",
              border: "1px solid #2348AB",
            }}
          >
            <span className="mx-2">
              <img src="./reupload.svg" alt="Reupload" />
            </span>
            Reupload
          </Button> */}
        </div>

        <p className={styles.reason}>
          <span>Reason :</span>{" "}
          {"Image quality is not clear. To sent Image quality is not clear"}
        </p>
      </div>
    </div>
  );
};

export default AttachmentPreviewModal;
